export default "__VITE_ASSET__DcktDOSQ__"